import { useQuery } from '@tanstack/react-query';

import { useClientContext } from 'context/ClientContext';
import { usePedidoCompraContext } from 'context/PedidoCompraContext';
import { useRequestListagem } from 'hooks/useRequestListagem';
import { Totalizador } from 'pages/compra/pedido/types';

export function useQueryTotalizador() {
    const { loja, setTotalizador } = usePedidoCompraContext();
    const requestListagem = useRequestListagem();
    const { tipoPedido } = useClientContext();
    const isTipoPedidoPadrao = tipoPedido === 'padrao';
    const idLoja = loja?.idLoja;

    return useQuery<Totalizador>({
        cacheTime: 0,
        queryKey: ['pedido-totalizador', idLoja],
        queryFn: () =>
            requestListagem({
                url: '/compra/pedidovltotalwrapper/rascunho',
                sort: [{ property: 'vlTotal', direction: 'ASC' }],
                filter: [{ property: 'idLoja', operator: 'in', value: [idLoja] }],
            }).then((res) => res.data),
        enabled: Boolean(loja) && isTipoPedidoPadrao,
        onSuccess: (response) => setTotalizador(response),
    });
}
